var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Amplify, Auth } from 'aws-amplify';
import { CognitoUser } from '@aws-amplify/auth';
class CognitoUserWrapper {
    constructor(underlyingUserObject) {
        this.underlyingUserObject = underlyingUserObject;
    }
    get attributes() {
        return this.underlyingUserObject.attributes;
    }
    get username() {
        var _a;
        return (_a = this.underlyingUserObject.username) !== null && _a !== void 0 ? _a : this.underlyingUserObject.getUsername();
    }
    get displayName() {
        return this.underlyingUserObject.displayName;
    }
}
class CognitoSessionWrapper {
    constructor(underlyingSession) {
        this.underlyingSession = underlyingSession;
    }
    getIdToken() {
        return new CognitoIdTokenWrapper(this.underlyingSession.getIdToken());
    }
}
class CognitoIdTokenWrapper {
    constructor(underlyingIdToken) {
        this.underlyingIdToken = underlyingIdToken;
    }
    get payload() {
        return this.underlyingIdToken.payload;
    }
    getJwtToken() {
        return this.underlyingIdToken.getJwtToken();
    }
    getExpiration() {
        return this.underlyingIdToken.getExpiration();
    }
    getIssuedAt() {
        return this.underlyingIdToken.getIssuedAt();
    }
}
export class CognitoAuthenticationManager {
    constructor(config) {
        this.supportsPasswordSignIn = true;
        this.supportsPasswordChange = true;
        this.accountManager = {
            forgotPassword(email) {
                return Auth.forgotPassword(email);
            },
            forgotPasswordSubmit(email, code, password) {
                return Auth.forgotPasswordSubmit(email, code, password);
            },
            signUp(options) {
                return __awaiter(this, void 0, void 0, function* () {
                    const result = yield Auth.signUp(options);
                    return {
                        user: new CognitoUserWrapper(result.user),
                        userId: result.userSub,
                    };
                });
            },
            resendVerificationCode(username) {
                return __awaiter(this, void 0, void 0, function* () {
                    yield Auth.resendSignUp(username);
                });
            },
        };
        Auth.configure(config);
        Amplify.configure(config);
    }
    currentAuthenticatedUser() {
        return __awaiter(this, void 0, void 0, function* () {
            let user;
            try {
                user = yield Auth.currentAuthenticatedUser();
            }
            catch (e) {
                // Ignore the standard return value if the user is not authenticated
                if (e !== 'The user is not authenticated') {
                    console.warn(e);
                }
            }
            if (user && !(user instanceof CognitoUser)) {
                console.warn('currentAuthenticatedUser returned an unexpected object', user);
            }
            return user ? new CognitoUserWrapper(user) : undefined;
        });
    }
    currentSession() {
        return __awaiter(this, void 0, void 0, function* () {
            return new CognitoSessionWrapper(yield Auth.currentSession());
        });
    }
    signIn(email, password) {
        return __awaiter(this, void 0, void 0, function* () {
            return new CognitoUserWrapper(yield Auth.signIn(email, password));
        });
    }
    signOut() {
        return Auth.signOut();
    }
    changePassword(user, oldPassword, newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            yield Auth.changePassword(user.underlyingUserObject, oldPassword, newPassword);
        });
    }
}
//# sourceMappingURL=Cognito.js.map